import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Avatar, Button, If, Text } from 'src/Components'
import AdditionalInfo from 'src/Components/shared/AdditionalInfo'
import { LO, REA } from 'src/constants/agent_types'
import { CMARequest, CMARequestSkipped } from 'src/constants/trackingEvents'

import styles from './Step.module.scss'

const PreviousREASection = ({ previousREA }) => (
  <div>
    <Text>
      <FormattedMessage
        id='Homeowner.cmaWizard.start.headlinePreviousREA'
        defaultMessage='Real estate agents help us get more accurate home values by knowing the neighborhood'
      />
    </Text>
    <Text color='quiet' className={styles.previousREA}>
      <If condition={previousREA.photo}>
        <Avatar src={previousREA.photo} size='xs' className={styles.avatar} />
      </If>
      <FormattedMessage
        id='Homeowner.cmaWizard.start.previousREA'
        defaultMessage='{agentName} was your real estate agent.'
        values={{
          agentName: (
            <Text color='white' element='span'>
              {previousREA.firstName} {previousREA.lastName}
            </Text>
          )
        }}
      />
    </Text>
  </div>
)

const CMASectionStart = ({ agent, close, startCMA, previousREA }) => (
  <>
    <If condition={agent.type === LO}>
      <If condition={previousREA}>
        <PreviousREASection previousREA={previousREA} />
      </If>
      <If condition={!previousREA}>
        <AdditionalInfo.Heading>
          <FormattedMessage
            id='Homeowner.cmaWizard.start.headlineLO'
            defaultMessage='{agent} can get a quick estimated value from a real estate agent near you.'
            values={{ agent: agent.firstName }}
          />
        </AdditionalInfo.Heading>
      </If>
    </If>
    <If condition={agent.type === REA}>
      <AdditionalInfo.Heading>
        <FormattedMessage
          id='Homeowner.cmaWizard.start.headlineREA'
          defaultMessage='{agent} is happy to get a quick estimated value'
          values={{ agent: agent.firstName }}
        />
      </AdditionalInfo.Heading>
      <Text color='quiet'>
        <FormattedMessage
          id='Homeowner.cmaWizard.start.bodyREA'
          defaultMessage="As an expert on your neighborhood, {agent} can easily give you a new estimate of your home's current value."
          values={{ agent: agent.firstName }}
        />
      </Text>
    </If>
    <Button.Group className={styles.buttonGroup}>
      <Button onClick={() => startCMA(true)} primary track={CMARequest}>
        <FormattedMessage
          id='Homeowner.cmaWizard.start.yesButton'
          defaultMessage='Yes, get value'
        />
      </Button>
      <If condition={previousREA}>
        <Button
          onClick={() => startCMA(false)}
          track={CMARequest}
          trackOptions={{ eventLabel: 'not previous agent' }}
        >
          <FormattedMessage
            id='Homeowner.cmaWizard.start.notPreviousRea'
            defaultMessage="Don't use {reaName}"
            values={{ reaName: previousREA && previousREA.firstName }}
          />
        </Button>
        <br />
      </If>
      <Button
        onClick={close}
        minimal={Boolean(previousREA)}
        className={previousREA && styles.skipLink}
        track={CMARequestSkipped}
      >
        <FormattedMessage
          id='Homeowner.cmaWizard.start.skipButton'
          defaultMessage='Skip for now'
        />
      </Button>
    </Button.Group>
    <If condition={previousREA}>
      <Text color='quiet' size='s'>
        <FormattedMessage
          id='Homeowner.cmaWizard.previousREA.subtext'
          defaultMessage="We'll reach out to the agent, they'll do a quick analysis, and then we'll send you the new estimate."
        />
      </Text>
    </If>
  </>
)

export default CMASectionStart
